// extracted by mini-css-extract-plugin
export var boxItems = "_6c-1";
export var boxItemsLg = "_6c-2";
export var button = "_6c-7";
export var buttonHoverless = "_6c-9";
export var buttonLg = "_6c-8";
export var filterGroupBox = "_6c-0";
export var icon = "_6c-3";
export var iconSecondary = "_6c-6";
export var iconWrapper = "_6c-4";
export var iconWrapperLg = "_6c-5";
export var truncatedLabel = "_6c-a";